export * from './manejo-parto/manejo-parto.component';
export * from './manejo-diagnostico-gestacao/manejo-diagnostico-gestacao.component';
export * from '../segment-personalizado/segment-personalizado.component';
export * from './manejo-inseminacao-artificial/manejo-inseminacao-artificial.component';
export * from './manejo-monta-natural/manejo-monta-natural.component';
export * from './manejo-desmame/manejo-desmame.component';
export * from './manejo-implante-progesterona/manejo-implante-progesterona.component';
export * from './manejo-aborto/manejo-aborto.component';
export * from './manejo-escore-corporal/manejo-escore-corporal.component';
export * from './popover-lista-exposicoes/popover-lista-exposicoes.component';